var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-link',{staticClass:"services__item",attrs:{"to":{
      name: 'service-single-local',
      params: { slug: _vm.s.slug },
      props: { remote: true },
    },"data-external":"false","data-url":_vm.s.name,"data-type":"citizen"}},[_c('div',{staticClass:"image",style:({ backgroundImage: 'url(' + _vm.s.image_url + ')' })}),_c('div',{staticClass:"info"},[_c('div',{staticClass:"name",domProps:{"innerHTML":_vm._s(_vm.highlightTerms(_vm.s.name))}}),_c('div',{staticClass:"descr"},[(_vm.s.description)?_c('span',[_vm._v(" "+_vm._s(_vm.s.description)+" ")]):_vm._e()])]),(_vm.s.new)?_c('div',{staticClass:"new-badge"},[_vm._v(" Нове ")]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }